import { InstagramFilled } from '@ant-design/icons';
import Title from 'antd/lib/skeleton/Title';
import React from 'react';
import {
  FacebookIcon,
  FacebookShareButton,
  InstapaperIcon,
  InstapaperShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

export const SocialMediaButtons = (props) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
      <FacebookShareButton
        style={{ marginRight: '10px' }}
        url={'https://ui.humbee.click'}
        quote={'HUMBEE Worlds First Business Welfare Platform'}
        hashtag='#Humbee'
      >
        <FacebookIcon size={36} />
      </FacebookShareButton>
      <TwitterShareButton
        style={{ marginRight: '10px' }}
        url={'https://ui.humbee.click'}
        title={'HUMBEE Worlds First Business Welfare Platform'}
        hashtag='#Humbee'
      >
        <TwitterIcon size={36} />
      </TwitterShareButton>
      <WhatsappShareButton
        style={{ marginRight: '10px' }}
        title={'HUMBEE Worlds First Business Welfare Platform'}
        url={'https://ui.humbee.click'}
      >
        <WhatsappIcon size={36} />
      </WhatsappShareButton>
    </div>
  );
};
